import { render, staticRenderFns } from "./l-merge-key-popup.vue?vue&type=template&id=bf06b36a&scoped=true"
import script from "./l-merge-key-popup.vue?vue&type=script&lang=js"
export * from "./l-merge-key-popup.vue?vue&type=script&lang=js"
import style0 from "./l-merge-key-popup.vue?vue&type=style&index=0&id=bf06b36a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf06b36a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf06b36a')) {
      api.createRecord('bf06b36a', component.options)
    } else {
      api.reload('bf06b36a', component.options)
    }
    module.hot.accept("./l-merge-key-popup.vue?vue&type=template&id=bf06b36a&scoped=true", function () {
      api.rerender('bf06b36a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mlocalization/views/popups/l-merge-key-popup.vue"
export default component.exports